// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State = require("../Control.Monad.State/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var rebuildFov = function (radius) {
    return function (origin) {
        return function (notSolid) {
            return function (mask) {
                var mark = function (point) {
                    return Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                        return "y";
                    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                        return "x";
                    }))(Data_Ord.ordInt)))(point)(true));
                };
                var doubleRadius = radius * radius | 0;
                var doubleDistance = function (x) {
                    return function (y) {
                        return (x * x | 0) + (y * y | 0) | 0;
                    };
                };
                var castLight = function (xx) {
                    return function (xy) {
                        return function (yx) {
                            return function (yy) {
                                var withDistance = function (meta) {
                                    return function (distance) {
                                        if (meta.blocked) {
                                            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(meta);
                                        };
                                        if (Data_Boolean.otherwise) {
                                            return Data_Foldable.foldM(Data_Foldable.foldableArray)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(withDeltaX(distance))({
                                                stop: false,
                                                blocked: meta.blocked,
                                                end: meta.end,
                                                newStart: meta.newStart,
                                                start: meta.start
                                            })(Data_Array.range(distance)(0));
                                        };
                                        throw new Error("Failed pattern match at Ritoppu.Mutation.FovMask (line 52, column 5 - line 54, column 88): " + [ meta.constructor.name, distance.constructor.name ]);
                                    };
                                };
                                var withDeltaX = function (deltaY) {
                                    return function (v) {
                                        return function (deltaX) {
                                            var rightSlope = (Data_Int.toNumber(deltaX) - 0.5) / (Data_Int.toNumber(deltaY) + 0.5);
                                            var leftSlope = (Data_Int.toNumber(deltaX) + 0.5) / (Data_Int.toNumber(deltaY) - 0.5);
                                            var current = {
                                                x: (origin.x + (deltaX * xx | 0) | 0) + (deltaY * xy | 0) | 0,
                                                y: (origin.y + (deltaX * yx | 0) | 0) + (deltaY * yy | 0) | 0
                                            };
                                            if (v.stop || v.start <= rightSlope) {
                                                return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(v);
                                            };
                                            if (v.end > leftSlope) {
                                                return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                                                    stop: true,
                                                    blocked: v.blocked,
                                                    end: v.end,
                                                    newStart: v.newStart,
                                                    start: v.start
                                                });
                                            };
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(doubleDistance(deltaX)(deltaY) <= doubleRadius)(mark(current)))(function () {
                                                var v1 = notSolid(current);
                                                if (v1 && v.blocked) {
                                                    return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                                                        blocked: false,
                                                        start: v.newStart,
                                                        end: v.end,
                                                        newStart: v.newStart,
                                                        stop: v.stop
                                                    });
                                                };
                                                if (!v1 && v.blocked) {
                                                    return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                                                        newStart: rightSlope,
                                                        blocked: v.blocked,
                                                        end: v.end,
                                                        start: v.start,
                                                        stop: v.stop
                                                    });
                                                };
                                                if (!v1 && deltaY < radius) {
                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(beam(deltaY + 1 | 0)(v.start)(leftSlope))(function () {
                                                        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                                                            blocked: true,
                                                            newStart: rightSlope,
                                                            end: v.end,
                                                            start: v.start,
                                                            stop: v.stop
                                                        });
                                                    });
                                                };
                                                return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(v);
                                            });
                                        };
                                    };
                                };
                                var beam = function (row) {
                                    return function (start) {
                                        return function (end) {
                                            return Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(start > end)(Data_Functor["void"](Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(Data_Foldable.foldM(Data_Foldable.foldableArray)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(withDistance)({
                                                newStart: 0.0,
                                                blocked: false,
                                                start: start,
                                                end: end,
                                                stop: false
                                            })(Data_Array.range(row)(radius))));
                                        };
                                    };
                                };
                                return beam(1)(1.0)(0.0);
                            };
                        };
                    };
                };
                var calc = Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(mark(origin))(function () {
                    return Control_Applicative.when(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(notSolid(origin))(Data_Foldable.for_(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Foldable.foldableArray)([ {
                        x: 1,
                        y: 1
                    }, {
                        x: 1,
                        y: -1 | 0
                    }, {
                        x: -1 | 0,
                        y: -1 | 0
                    }, {
                        x: -1 | 0,
                        y: 1
                    } ])(function (v) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(castLight(0)(v.x)(v.y)(0))(function () {
                            return castLight(v.x)(0)(0)(v.y);
                        });
                    }));
                });
                var visible = Control_Monad_State.execState(calc)(Data_Map_Internal.empty);
                var seen = Data_Set.union(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(mask.seen)(Data_Set.fromFoldable(Data_Set.foldableSet)(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(Data_Map.keys(visible)));
                return {
                    visible: visible,
                    seen: seen
                };
            };
        };
    };
};
module.exports = {
    rebuildFov: rebuildFov
};
